import { axiosInstance } from '../axios';
import { asyncGet, asyncPatch, asyncPost } from '../utils';
import { Context, ScoreResponse, Subscription } from './Subscription.model';

const subscriptionPath = `subscriptions`;

export function subscriptionApi() {
  return Object.freeze({
    updateSubscription: (subscriptionUuid: string, subscription: Partial<Subscription>) =>
      asyncPatch(axiosInstance(), `${encodeURI(`${subscriptionPath}/${subscriptionUuid}`)}`, subscription),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // initSubscription: (payload: any) => asyncPost(axiosInstance(), `${encodeURI(`${subscriptionPath}`)}`, payload),
    getSubscriptionScore: (subscriptionUuid: string): Promise<ScoreResponse> =>
      asyncGet(axiosInstance(), `${encodeURI(`${subscriptionPath}/${subscriptionUuid}/response`)}`),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    postSubscriptionScore: (payload: any) =>
      asyncPost(axiosInstance(), `${encodeURI(`${subscriptionPath}/response`)}`, payload),

    // getInsurances: (subscriptionUuid: string): Promise<Insurance> =>
    //   asyncGet(axiosInstance(), `${encodeURI(`${subscriptionPath}/${subscriptionUuid}/insurances`)}`),
    getContext: (subscriptionUuid: string): Promise<Context> =>
      asyncGet(axiosInstance(), `${encodeURI(`${subscriptionPath}/${subscriptionUuid}/context`)}`),
  });
}
